import { Component } from '@angular/core';
import { RateLine } from '../../../_types/rate-line';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { RateLinesService } from '../../../_services/rates-lines.service';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { RatesTemplatesLinesService } from '../../../_services/rates-templates-lines.service';
import { RateTemplateLine } from '../../../_types/rate-template-line';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';

@Component({
    selector: 'app-line',
    templateUrl: './line.component.html',
    styleUrls: ['./line.component.scss'],
    standalone: false
})
export class RateTemplateLineComponent {
  public rateLines: RateLine[] = [];
  public rateTemplateLineFormGroup!: RxFormGroup;
  public rateTemplateLine: RateTemplateLine = new RateTemplateLine();

  public existentRateLines: any[] = [];
  public rateTemplateId: string = '';
  public rateId: string = '';

  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    code: new Filter(FilterOperation.contains, 'code'),
  };
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    private rateLinesService: RateLinesService,
    private rateTemplateLinesService: RatesTemplatesLinesService,
    private messageService: MessageService,
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private dialogService: DialogService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService
  ) {
    this.rateTemplateLine.quantity = 1;
    this.rateTemplateLineFormGroup = this.formBuilder.formGroup<RateTemplateLine>(this.rateTemplateLine) as RxFormGroup;
  }

  async ngOnInit() {
    let rateTemplateLineId = this.config.data.rateTemplateLineId;
    this.rateId = this.config.data.rateId;

    if (rateTemplateLineId) {
      await this.loadRateTemplateLine(rateTemplateLineId);
      this.loadRateLines(this.rateTemplateLine);
    } else {
      this.rateTemplateLine.rateTemplateId = this.config.data.rateTemplateId;
      this.loadRateLines(null);
    }

    this.rateTemplateLineFormGroup.patchValue(this.rateTemplateLine);

    if (this.config.data && this.config.data.existentRateLines) {
      this.existentRateLines = this.config.data.existentRateLines;
    }

    this.allowWrite = true;
    this.allowDelete = true;
  }

  public async loadRateTemplateLine(rateTemplateLineId: string) {
    this.rateTemplateLine = await firstValueFrom(this.rateTemplateLinesService.get(rateTemplateLineId));
  }

  public async loadRateLines(rateTemplateLine: RateTemplateLine | null) {

    let params: IParamsCollection = {
      page: { size: 1000 }
    }

    // filtrar por rateId
    this.filters.rateId = new Filter(FilterOperation.equals, 'rateId', '', this.rateId);

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.rateLinesService.all(params));
    this.rateLines = response.data;

    if (this.existentRateLines.length > 0) {
      // remove this rate line from existent rate lines
      this.existentRateLines = this.existentRateLines.filter((existentRateLine: any) => {
        return existentRateLine.rateLineId !== rateTemplateLine?.rateLineId;
      });
      // remove existent rate lines
      this.rateLines = this.rateLines.filter((rateLine: any) => {
        return !this.existentRateLines.some((existentRateLine: any) => existentRateLine.rateLineId === rateLine.id);
      });
    }

    this.totalRecords = this.rateLines.length;
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.rateTemplateLineFormGroup);
    if (valid) {
      this.rateTemplateLine = Object.assign(this.rateTemplateLine, this.rateTemplateLineFormGroup.value);

      let rateTemplateLine = await firstValueFrom(this.rateTemplateLinesService.save(this.rateTemplateLine));
      this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Línea de baremo guardada correctamente." });
      this.dynamicDialogRef.close();
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  delete() {

  }

}
